import React, { useEffect, useState } from "react";
import DashboardCard from "./DashboardCard";
import DashboardChart from "./DashboardChart";
import axiosInstance from "../../utils/axios";
import { entitiesConfig } from "../../components/templateComponents/constants";
import "./Dashboard.css";

const Dashboard = () => {
  const [data, setData] = useState({
    users: 0,
    shops: 0,
    merchants: 0,
    serviceProviders: 0,
    establishments: 0,
  });

  const endpoints = entitiesConfig.dashboard.endpoints;

  useEffect(() => {
    const fetchCounts = async () => {
      try {
        const fetchCount = async (
          endpoint,
          key = "message",
          statusKey = "status"
        ) => {
          const response = await axiosInstance.post(endpoint, {
            view_type: "view",
          });
          const result = response.data;

          if (
            (result[statusKey] === "success" ||
              result[statusKey] === "Success") &&
            result[key]
          ) {
            return Object.keys(result[key]).length;
          }
          return 0;
        };

        const [users, shops, merchants, serviceProviders, establishments] =
          await Promise.all([
            fetchCount(endpoints.users, "Data", "Status"),
            fetchCount(endpoints.shops),
            fetchCount(endpoints.merchants),
            fetchCount(endpoints.serviceProviders),
            fetchCount(endpoints.establishments, "Data", "Status"),
          ]);

        setData({ users, shops, merchants, serviceProviders, establishments });
      } catch (error) {
        console.error("Error fetching dashboard data:", error);
      }
    };

    fetchCounts();
  }, []);

  return (
    <div className="dashboard-container">
      <h2 className="dashboard-title">Dashboard</h2>
      <div className="cards-container">
        <DashboardCard
          title="Establishments"
          value={data.establishments}
          icon="🏛️"
          color="#f093fb"
        />
        <DashboardCard
          title="Merchants"
          value={data.merchants}
          icon="🏪"
          color="#667eea"
        />
        <DashboardCard
          title="Shops"
          value={data.shops}
          icon="🛍️"
          color="#43e97b"
        />
        <DashboardCard
          title="Service Providers"
          value={data.serviceProviders}
          icon="🧰"
          color="#f6d365"
        />
        <DashboardCard
          title="Users"
          value={data.users}
          icon="👤"
          color="#a18cd1"
        />
      </div>

      <div className="charts-container">
        <DashboardChart
          chartSeries={[
            data.establishments,
            data.merchants,
            data.shops,
            data.serviceProviders,
            data.users,
          ]}
          chartLabels={[
            "Establishments",
            "Merchants",
            "Shops",
            "Service Providers",
            "Users",
          ]}
        />
      </div>
    </div>
  );
};

export default Dashboard;
